import { render, staticRenderFns } from "./CreateTopUpPointTransaction.vue?vue&type=template&id=015d6532&scoped=true"
import script from "./CreateTopUpPointTransaction.vue?vue&type=script&lang=js"
export * from "./CreateTopUpPointTransaction.vue?vue&type=script&lang=js"
import style0 from "./CreateTopUpPointTransaction.vue?vue&type=style&index=0&id=015d6532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d6532",
  null
  
)

export default component.exports